import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BrandStory from './components/BrandStory';
import Reputation from './components/Reputation';
import ContactInfo from './components/ContactInfo';
import { generateBreadcrumbSchema, generateOrganizationSchema } from '@/mocks/schema';

const BASE_URL = 'https://yuriclub.cn';

export default function AboutPage() {
  const pageTitle = '关于百合会 - 百合文化爱好者社区 | 百合会';
  const pageDesc = '百合会是专为百合文化爱好者打造的核心聚集地。了解百合会的品牌故事、用户口碑与联系方式，加入我们与志同道合的伙伴一起探索百合作品的魅力。';
  const pageKeywords = '百合会,百合文化,关于百合会,百合社区,百合爱好者';

  const jsonLd = [
    generateOrganizationSchema(),
    generateBreadcrumbSchema(
      [{ label: '首页', href: '/' }, { label: '关于我们' }],
      BASE_URL
    ),
    {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: pageTitle,
      description: pageDesc,
      url: `${BASE_URL}/about`,
    },
  ];

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={`${BASE_URL}/about`}
        jsonLd={jsonLd}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 bg-background-50">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />
        <BrandStory />
        <Reputation />
        <ContactInfo />
      </main>
      <Footer />
    </>
  );
}